/** Marks of a day not worked, drawn in the text's colour: a public holiday by its flag, a day
 * off — a weekend or a holiday — by a beach umbrella. */
export function HolidayIcon({ size = 12 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M5 22V3" />
      <path d="M5 4h12l-3 4.5 3 4.5H5" fill="currentColor" fillOpacity="0.25" />
    </svg>
  );
}

export function DayOffIcon({ size = 12 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M3 11a9 9 0 0 1 18 0z" fill="currentColor" fillOpacity="0.2" />
      <path d="M12 11v9M12 20c0 1.5 3 1.5 3 0" />
      <path d="M12 2v1" />
    </svg>
  );
}
